import Rails from "@rails/ujs"
import { Controller } from "stimulus"
import mdkController from "./mdk_controller"

export default class extends mdkController {
  static targets = ['form'];
  static classes = ['errorm','hide'];
  static values = {validateurl: String, validateflag: String};
  formTargetConnected() {
    this.control_show_and_hide();
    super.connect();
  }



  validate(event){
    const el = event.currentTarget;
    const pa = el.parentElement;
    const params = event.params;
    let errorM = pa.querySelector("."+this.errormClass);
    if(errorM == undefined){
      errorM = pa.parentElement.querySelector("."+this.errormClass);
      if(errorM == undefined){
        errorM = pa.parentElement.parentElement.querySelector("."+this.errormClass);
      }
    }
    this.control_show_and_hide()
    const formData = new FormData(this.formTarget);
    formData.append("type",params.column);
    Rails.ajax({
      url: this.validateurlValue,
      type: "POST",
      dataType: 'json',
      data: formData,
      success: (response)=> {
        errorM.innerHTML = response;
      }
    });
  }

  validateAll(event){
    const el = event.currentTarget;
    el.disabled = true;
    let errorMs = document.querySelectorAll("."+this.errormClass);
    errorMs.forEach(function (m) {
      m.textContent = "";
    });
    const formData = new FormData(this.formTarget);
    const allErrorE = document.getElementById("allError");
    Rails.ajax({
      url: this.validateurlValue,
      type: "POST",
      dataType: 'json',
      data: formData,
      success: (response)=> {
        if(response != null && Object.keys(response).length > 0){
          let allErrorTxt = "";
          Object.keys(response).forEach(function (key) {
            errorMs.forEach(function (m) {
              if (m.dataset.errormtarget == key){
                m.innerHTML = response[key];
                allErrorTxt += response[key]+"<br />";
              }
            })
          });
          allErrorE.innerHTML = allErrorTxt;
          allErrorE.classList.remove(this.hideClass);
          el.disabled = false;
        }else{
            allErrorE.innerHTML = '';
            allErrorE.classList.add(this.hideClass);
          this.formTarget.submit();
        }
      }
    });
  }
  // リリース当初不使用だが、今後利用するかもしれないので残しておく
  copy_address(e){
    if(e.target.checked){
      this.formTarget.querySelector("#prescription_invoice_post_code").value = this.formTarget.querySelector("#prescription_send_post_code").value
      this.formTarget.querySelector("#prescription_invoice_prefecture").value = this.formTarget.querySelector("#prescription_send_prefecture").value
      this.formTarget.querySelector("#prescription_invoice_city").value = this.formTarget.querySelector("#prescription_send_city").value
      this.formTarget.querySelector("#prescription_invoice_address").value = this.formTarget.querySelector("#prescription_send_address").value
    }
  }

  control_show_and_hide(){
    //お薬処方まわりの表示、非表示
    const delivery_to_shop = this.formTarget.querySelector("#prescription_delivery_to_shop")
    const pharmacy_information = this.formTarget.querySelector('#pharmacy_information_input_field')
    const medication_guidance = this.formTarget.querySelector('#medication_guidance_input_field')
    const address_input_field = this.formTarget.querySelector('#address_input_field')
    const send_address = this.formTarget.querySelector('#send_address_input_field')
    const medication_guidance_on = this.formTarget.querySelector('#prescription_medication_guidance')
    //支払クレジットカード限定のときのために{hidden: true}をダミーで代入
    const invoice_address_copy = this.formTarget.querySelector("#invoice_address_copy") ?? { hidden: true }
    if(delivery_to_shop != null){
      //診察（処方ありの場合）
      if(delivery_to_shop.checked){
        pharmacy_information.hidden = false;
        medication_guidance.hidden = true;
        send_address.hidden = true;
        invoice_address_copy.hidden = true;
        medication_guidance_on.value = null;
      } else {
        pharmacy_information.hidden = true;
        medication_guidance.hidden = false;
        send_address.hidden = false;
        send_address.appendChild(address_input_field);
        medication_guidance_on.value = "mail";
        const medication_guidance_tel = this.formTarget.querySelector('#prescription_medication_guidance_tel');
        const medication_consent = this.formTarget.querySelector('#medication_consent_input_field');
        const guidance_time = this.formTarget.querySelector('#guidance_time_input_field');
//        if(medication_guidance_tel != null && medication_guidance_tel.checked){
//          medication_consent.hidden = true;
//          guidance_time.hidden = false;
//        }else{
//          medication_consent.hidden = false;
//          guidance_time.hidden = true;
//        }
      }
    }else{
      //医療相談の場合
      address_input_field.hidden = true;
    }

    //支払関連の表示・非表示
    const credit = this.formTarget.querySelector("#reservation_payment_method_credit")
    const invoice = this.formTarget.querySelector("#reservation_payment_method_conveni")
    const card_info = this.formTarget.querySelector("#card_info_input_field")
    const invoice_address = this.formTarget.querySelector("#invoice_address_input_field")
    const conveni_notice = this.formTarget.querySelector("#coiveniNotice")
    if(credit != null && card_info != null){
      if(credit.checked){
        card_info.hidden = false;
      }else{
        card_info.hidden = true;
      }
    }
    //コンビニ支払のラジオボタンが存在している場合
    if(invoice != null && invoice_address != null){
      if(invoice.checked){
        if(delivery_to_shop == null || delivery_to_shop.checked) {
          invoice_address.appendChild(address_input_field);
          address_input_field.hidden = false
        }
        invoice_address.hidden = false
        conveni_notice.hidden = false;
      }else{
        invoice_address.hidden = true
        conveni_notice.hidden = true;
      }
    }
  }

  notice_hidden(e){
    const notice = this.formTarget.querySelector("#guidance_time_notice")
    if(e.target.value == 12){
      notice.classList.remove('is-hidden')
    }else{
      notice.classList.add('is-hidden')
    }
  }

}
